"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _inputPresentation = _interopRequireDefault(require("../../__internal__/input/input-presentation.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const datePickerWidth = {
  large: "140px",
  medium: "135px",
  small: "120px"
};
const StyledDateInput = _styledComponents.default.div`
  ${_styledSystem.margin}

  & ${_inputPresentation.default} {
    flex: none;
    width: ${({
  size
}) => size ? datePickerWidth[size] : "135px"};
  }
`;
StyledDateInput.propTypes = {
  size: _propTypes.default.oneOf(["small", "medium", "large"])
};
StyledDateInput.defaultProps = {
  theme: _base.default
};
var _default = StyledDateInput;
exports.default = _default;